import { render, staticRenderFns } from "./ExpiringSchedules.vue?vue&type=template&id=04b8bc58&scoped=true&"
import script from "./ExpiringSchedules.vue?vue&type=script&lang=js&"
export * from "./ExpiringSchedules.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringSchedules.vue?vue&type=style&index=0&id=04b8bc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8bc58",
  null
  
)

export default component.exports